import axios from "axios";
// import { toastr } from "react-redux-toastr";

const instance = axios.create();

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response.data) {
      // toastr.error("", error?.response.data.message);
    }
    return Promise.reject(error);
  }
);
export default instance;
